import { LogoutUser } from "../services/Firebase";
import { useNavigate } from "react-router-dom";

export default function MultipleAccount() {

    const navigate = useNavigate();

    const OnContinueClick = () => {
        localStorage.removeItem("accessToken");
        navigate(`/`)
        LogoutUser();
    }

    return (
        <>
            {/* BACKDROP */}
            <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" />

            {/* POPUP CONTAINER */}
            <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
                <div
                    className="
            w-full max-w-md
            rounded-3xl
            border border-white/20
            bg-black/40
            backdrop-blur-xl
            shadow-2xl
            px-8 py-10
          "
                >
                    {/* TITLE */}
                    <h2 className="text-white text-2xl font-semibold text-center">
                        Multiple Device Detected!
                    </h2>

                    {/* SUBTITLE */}
                    <p className="text-gray-300 text-center mt-2">
                        You have been logged in from another device. Logging you out
                    </p>

                    {/* OKAY BUTTON */}
                    <button
                        onClick={OnContinueClick}
                        className="w-full py-3 rounded-full text-lg font-semibold transition bg-red-500 text-white hover:bg-red-500 mt-16"
                    >
                        Okay
                    </button>
                </div>
            </div>
        </>
    );
}